export default __webpack_public_path__ + "static/media/Icon8.1e4f9824.png";